// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"96":"056bd8","216":"2f25d8","344":"e2414a","662":"9ae009","818":"f6cbf3"}[chunkId] + ".js";
};